import type { Identifier } from "ra-core";

export interface GulaTask {
  id: Identifier;
  contact_id: Identifier;
  type?: string | null;
  text?: string | null;
  due_date?: string | null;
  done_date?: string | null;
  sales_id?: Identifier | null;
  auto_key?: string | null;
}

export type TaskGroupKey = "overdue" | "today" | "tomorrow" | "week" | "later";

export const TASK_GROUPS: { key: TaskGroupKey; label: string }[] = [
  { key: "overdue", label: "Vencidas" },
  { key: "today", label: "Hoy" },
  { key: "tomorrow", label: "Mañana" },
  { key: "week", label: "Próximos 7 días" },
  { key: "later", label: "Más adelante" },
];

const startOfDay = (date: Date) => {
  const copy = new Date(date);
  copy.setHours(0, 0, 0, 0);
  return copy;
};

export const addDays = (date: Date, days: number) => {
  const copy = new Date(date);
  copy.setDate(copy.getDate() + days);
  return copy;
};

/** Which agenda bucket a due date falls into (no date = today). */
export const taskGroup = (
  dueDate?: string | null,
  now = new Date(),
): TaskGroupKey => {
  if (!dueDate) return "today";
  const due = new Date(dueDate);
  const today = startOfDay(now);
  if (due < today) return "overdue";
  if (due < addDays(today, 1)) return "today";
  if (due < addDays(today, 2)) return "tomorrow";
  if (due < addDays(today, 8)) return "week";
  return "later";
};

export const isTaskOverdue = (dueDate?: string | null, now = new Date()) =>
  !!dueDate && new Date(dueDate) < startOfDay(now);

export const formatDue = (dueDate?: string | null): string => {
  if (!dueDate) return "";
  const due = new Date(dueDate);
  const time = due.toLocaleTimeString("es-ES", {
    hour: "2-digit",
    minute: "2-digit",
  });
  const group = taskGroup(dueDate);
  if (group === "today") return time;
  if (group === "tomorrow") return `mañana ${time}`;
  return `${due.toLocaleDateString("es-ES", { weekday: "short", day: "numeric", month: "short" })} ${time}`;
};
